import angular from 'angular'

import Servers from '../shared-ng/servers/index'
import MainAPI from './main-api.service.js'
import AuthAPI from './auth-api.service.js'

export default angular.module('rb.api', [ Servers ])
  .service('MainAPI', MainAPI)
  .service('AuthAPI', AuthAPI)
